// extracted by mini-css-extract-plugin
export default {"menu":"SideBarMenu_menu__qVXi3"};